'use strict';

angular.module('msCore').service('overlaySvc', ['$state', function ($state) {
  var display;
  /**
   * Set up an overlay
   * @param  {string} translatePrefix The prefix of all the translations (as a translation string). This translation should at least contain a title, but can also contain a subtitle and content.
   * @param  {string} options         An options object. Notably, this can include .redirect, which is a ui-router state and a .timeout which is an amount of time before the overlay automatically closes.
   */
  this.overlay = function (translatePrefix, options, callback) {
    if (angular.isObject(translatePrefix)) {
      display({
        dataModel: translatePrefix,
        template: options.template
      }, null, null, null, callback);
    } else {
      var _options = options || {};
      var _args = _.get(options, 'args');
      if (!angular.isFunction(display)) {
        $state.go(_options.redirect, _args);
        return;
      }
      display({
        prefix: translatePrefix,
        options: _options || {}
      }, _options.redirect, _options.timeout, _options.overlayTimeout);
    }
  };
  /**
   * Set the callback that the service will use to setup the actual overlay.
   * @param {Function} callback the function that will be called with any new overlay requests
   */
  this.setCallback = function (callback) {
    display = callback;
  };
}]);